// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"634eb0d1","206":"b1b0d522","256":"e0ed6b94","398":"2c956523","713":"710083df","797":"4fd79f26","963":"505ef095"}[chunkId] + ".chunk.js";
};